function applicationSourceSearchLabel(source) {
  return source === 'app' ? 'Saarthi app' : 'Website';
}

export function profileIdForDriverApplication(driver) {
  if (!driver) return '';
  const linked = String(driver.app_profile_id || '').trim();
  if (linked) return linked;
  if (driver.signup_source === 'app') return String(driver.id || '').trim();
  return '';
}

/** Merge Saarthi profile email when the hiring row has none (common for app signups). */
export async function attachProfileEmailsToApplications(supabaseClient, applications) {
  if (!supabaseClient || !applications?.length) return applications;

  const profileIds = [
    ...new Set(applications.map(profileIdForDriverApplication).filter(Boolean)),
  ];
  if (!profileIds.length) return applications;

  const { data: profiles, error } = await supabaseClient
    .from('profiles')
    .select('id,email')
    .in('id', profileIds);

  if (error || !profiles?.length) return applications;

  const emailById = new Map(
    profiles.map((row) => [String(row.id), String(row.email || '').trim()])
  );

  return applications.map((driver) => {
    const profileId = profileIdForDriverApplication(driver);
    const profileEmail = profileId ? emailById.get(profileId) || '' : '';
    const rowEmail = String(driver.email || '').trim();
    const email = rowEmail || profileEmail;
    return {
      ...driver,
      email: email || driver.email,
      profile_email: profileEmail || null,
    };
  });
}

export function driverApplicationMatchesSearch(driver, rawQuery) {
  const q = String(rawQuery || '').trim().toLowerCase();
  if (!q) return true;
  if (!driver) return false;

  const qDigits = q.replace(/\D/g, '');
  const phoneDigits = String(driver.phone || '').replace(/\D/g, '');

  const textFields = [
    driver.full_name,
    driver.name,
    driver.email,
    driver.profile_email,
    driver.city,
    driver.district,
    driver.state,
    driver.license_number,
    driver.referral_code,
    driver.referred_by,
    driver.vehicle_number,
    applicationSourceSearchLabel(driver.signup_source),
  ];

  if (textFields.some((value) => String(value || '').toLowerCase().includes(q))) {
    return true;
  }

  if (qDigits.length >= 3 && phoneDigits.includes(qDigits)) {
    return true;
  }

  return false;
}
